import {useEffect, useRef, useState} from "react";

import NoConfigsData from "../configs/NoConfigsData";
import TableSender from "./TableSender";
import LoaderSpinner from "context/LoaderSpinner";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import FilterModel from "components/FilterModel";
import {PagerModel} from "components/paginator/PaginationModel";
import ConditionalRender from "components/ConditionalRender";
import OrderingModel from "components/ordering/OrderingModel";
import {SwalAlertClass} from "core/swalClass";
import ItemsModel from "core/itemsModel";
import {useTranslation} from "react-i18next";
import axiApi from "ApiCaller";
import FilterSender from "./FilterSender";
import ModalConfigSelect from "./ModalConfigSelect";

const ButtonsActions = function () {
    return {
        title: "",
        counter: 0,
        send: {
            active: false,
            disabled: true,
            onClick: () => {},
        },
        searcher: (e) => {},
    };
};

const TabSender = ({_TC}) => {
    const {t: _Tf} = useTranslation("forms");
    const buttonsAct = new ButtonsActions();
    const [buttonsTB, setButtonsTB] = useState(buttonsAct);
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShow, setItemsShow] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [params, setParams] = useState({models: [], groups: []});
    const [showModalSender, setShowModalSender] = useState(false);

    const headersTable = [
        {
            name: (
                <>
                    UUID
                    <br />
                    {_TC("label.model")}
                </>
            ),
            attr: 0,
            direction: "asc",
            active: true,
            default: true,
        },
        {name: _TC("label.format"), attr: 1, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsAct};
        buttons.title = _TC("basic");
        buttons.send.onClick = onClickSend;
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchPostData();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchPostData();
        filters.current.filter = () => {
            pagerModelRef.current.paging.page = 1;
            fetchPostData();
        };

        fetchGetData();
    }, []);

    const onClickSend = () => {
        if (items.current.chosen.length === 0) {
            return false;
        }
        setShowModalSender(true);
    };

    const fetchGetData = async () => {
        setIsLoading(true);
        const resp = await axiApi.get("/api/devices/pga/senders/");

        if (resp.data) {
            pagerModelRef.current.active = resp.data.items.length > 0;
            items.current.all = [...resp.data.items];
            items.current.showed = [...resp.data.items];
            items.current.chosen = [];
            setItemsShow([...items.current.showed]);
            setParams(resp.data.params);
            pagerModelRef.current.paging.setPager(resp.data);
        }
        setIsLoading(false);
    };

    const fetchPostData = async () => {
        setIsLoading(true);
        const resp = await axiApi.post("/api/devices/pga/senders/", filters.current.chosen, {
            params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
        });
        if (resp.data.status) {
            items.current.showed = [...resp.data.items];
            items.current.chosen = [];
            setItemsShow([...items.current.showed]);
            pagerModelRef.current.paging.setPager(resp.data);
        } else {
            console.error("Error en alertSetup.api()");
            Alert.warning("Error en el servicio", "No se han podido recuperar las alertas");
        }
        setIsLoading(false);
    };

    return (
        <>
            <div style={{position: "sticky", top: "71px", zIndex: 900, background: "white"}}>
                <FilterSender actions={buttonsTB} items={items} params={params} filters={filters} _TC={_TC} />
            </div>
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="145px" chosen={items.current.chosen} />
            <LoaderSpinner isLoading={isLoading}>
                <NoConfigsData items={itemsShow}>
                    <TableSender
                        items={items}
                        itemsShow={itemsShow}
                        buttonsTB={buttonsTB}
                        setButtonsTB={setButtonsTB}
                        checkedAll={checkedAll}
                        setCheckedAll={setCheckedAll}
                        orderingRef={orderingRef}
                        _TC={_TC}
                    />
                </NoConfigsData>
            </LoaderSpinner>
            <ConditionalRender condition={showModalSender}>
                <ModalConfigSelect
                    show={showModalSender}
                    setShow={setShowModalSender}
                    setItemsParent={setItemsShow}
                    items={items}
                    _TC={_TC}
                />
            </ConditionalRender>
        </>
    );
};
export default TabSender;
